<template>
  <div>
    <div class="gps">
      <div class="input-group">
        <div class="input-group-prepend">
          <button
            class="btn btn-secondary"
            type="button"
            @click="handleGetCurrentPosition()"
          >
            <i class="fas fa-spinner fa-spin mr-1" v-if="GPS_IS_LOADING"></i>
            <i class="fas fa-crosshairs mr-1" v-else></i>GPS
          </button>
        </div>
      </div>
      <div v-if="message" class="alert" :class="[`alert-${messageType}`]">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "GpsButton",
  computed: {
    ...mapState({
      GPS_POSITION: (state) => state.map.GPS_POSITION,
      GPS_IS_LOADING: (state) => state.map.GPS_IS_LOADING,
      message: (state) => state.map.message,
      messageType: (state) => state.map.messageType,
    }),
  },
  methods: {
    ...mapActions({
      GPS_GET_CURRENT_POSITION: "map/GPS_GET_CURRENT_POSITION",
    }),
    async handleGetCurrentPosition() {
      try {
        const currentPosition = await this.GPS_GET_CURRENT_POSITION();
        if (currentPosition) {
          this.$emit("input", currentPosition);
        }
      } catch (error) {
        // vuex message contains the error
      }
    },
  },
};
</script>

<style scoped>
.gps {
  position: relative;
  width: 100%;
}
</style>
